// Preguntas verificadas sobre anatomía de la cabeza y cara
export const headQuestions = [
  { 
    id: 200, 
    question: "¿Cuántos huesos forman el cráneo humano?", 
    options: ["18", "22", "26", "30"], 
    correctAnswer: 1, 
    region: "cabeza",
    explanation: "El cráneo humano está formado por 22 huesos: 8 del neurocráneo (frontal, occipital, etmoides, esfenoides, 2 parietales y 2 temporales) y 14 del viscerocráneo o esqueleto facial."
  },
  { 
    id: 201, 
    question: "¿Qué hueso NO forma parte del neurocráneo?", 
    options: ["Frontal", "Parietal", "Mandíbula", "Occipital"], 
    correctAnswer: 2, 
    region: "cabeza",
    explanation: "La mandíbula es el único hueso móvil del cráneo y forma parte del viscerocráneo (esqueleto facial), no del neurocráneo que protege el cerebro."
  },
  { 
    id: 202, 
    question: "¿Cuál es el músculo de la masticación más potente?", 
    options: ["Temporal", "Masetero", "Pterigoideo medial", "Pterigoideo lateral"], 
    correctAnswer: 1, 
    region: "cabeza",
    explanation: "El masetero es el músculo más potente de la masticación. Puede generar una fuerza de cierre de hasta 70 kg/cm² y es responsable de elevar la mandíbula."
  },
  { 
    id: 203, 
    question: "¿Qué nervio craneal inerva los músculos de la expresión facial?", 
    options: ["V (Trigémino)", "VII (Facial)", "IX (Glosofaríngeo)", "X (Vago)"], 
    correctAnswer: 1, 
    region: "cabeza",
    explanation: "El nervio facial (VII par craneal) es responsable de la inervación motora de todos los músculos de la expresión facial, permitiendo gestos como sonreír, fruncir el ceño, etc."
  },
  { 
    id: 204, 
    question: "¿Cuántos pares de nervios craneales existen?", 
    options: ["10", "12", "14", "16"], 
    correctAnswer: 1, 
    region: "cabeza",
    explanation: "Existen 12 pares de nervios craneales que emergen directamente del cerebro. Controlan funciones sensoriales y motoras de la cabeza, cuello y órganos internos."
  },
  { 
    id: 205, 
    question: "¿Qué hueso forma la frente?", 
    options: ["Parietal", "Temporal", "Frontal", "Etmoides"], 
    correctAnswer: 2, 
    region: "cabeza",
    explanation: "El hueso frontal forma la frente y también la parte superior de las órbitas oculares. Es un hueso único que se fusiona en la línea media durante la infancia."
  },
  { 
    id: 206, 
    question: "La articulación temporomandibular conecta:", 
    options: ["Temporal y mandíbula", "Maxilar y mandíbula", "Cigomático y temporal", "Esfenoides y mandíbula"], 
    correctAnswer: 0, 
    region: "cabeza",
    explanation: "La ATM (articulación temporomandibular) conecta el hueso temporal del cráneo con la mandíbula. Es una de las articulaciones más utilizadas del cuerpo humano."
  },
  { 
    id: 207, 
    question: "¿Qué músculo cierra el ojo?", 
    options: ["Orbicular del ojo", "Elevador del párpado", "Recto superior", "Frontal"], 
    correctAnswer: 0, 
    region: "cabeza",
    explanation: "El músculo orbicular del ojo rodea la órbita ocular y es responsable del cierre de los párpados, tanto voluntario como reflejo (parpadeo)."
  },
  { 
    id: 208, 
    question: "¿Qué seno paranasal es el más grande?", 
    options: ["Frontal", "Etmoidal", "Maxilar", "Esfenoidal"], 
    correctAnswer: 2, 
    region: "cabeza",
    explanation: "El seno maxilar es el seno paranasal más grande. Se localiza en el hueso maxilar superior y ayuda a disminuir el peso del cráneo y resonar la voz."
  },
  { 
    id: 209, 
    question: "¿Qué nervio craneal es responsable de la olfación?", 
    options: ["I (Olfatorio)", "II (Óptico)", "V (Trigémino)", "VII (Facial)"], 
    correctAnswer: 0, 
    region: "cabeza",
    explanation: "El nervio olfatorio (I par craneal) transmite información olfativa desde la mucosa nasal hasta el bulbo olfatorio en el cerebro, permitiéndonos percibir olores."
  },
  { 
    id: 210, 
    question: "¿Cuántos músculos extraoculares mueven cada ojo?", 
    options: ["4", "6", "8", "10"], 
    correctAnswer: 1, 
    region: "cabeza",
    explanation: "Cada ojo tiene 6 músculos extraoculares: 4 rectos (superior, inferior, medial, lateral) y 2 oblicuos (superior e inferior) que permiten movimientos oculares precisos."
  },
  { 
    id: 211, 
    question: "La glándula parótida produce:", 
    options: ["Lágrimas", "Saliva", "Mucosidad nasal", "Cerumen"], 
    correctAnswer: 1, 
    region: "cabeza",
    explanation: "La glándula parótida es la glándula salival más grande. Produce aproximadamente el 25% de la saliva total y libera su secreción a nivel del segundo molar superior."
  },
  { 
    id: 212, 
    question: "¿Qué hueso contiene el órgano de la audición?", 
    options: ["Temporal", "Occipital", "Esfenoides", "Etmoides"], 
    correctAnswer: 0, 
    region: "cabeza",
    explanation: "El hueso temporal contiene la porción petrosa donde se aloja el oído interno, incluyendo la cóclea (órgano de la audición) y el sistema vestibular (equilibrio)."
  },
  { 
    id: 213, 
    question: "¿Cuántos dientes permanentes tiene un adulto?", 
    options: ["28", "30", "32", "34"], 
    correctAnswer: 2, 
    region: "cabeza",
    explanation: "Un adulto completo tiene 32 dientes permanentes: 8 incisivos, 4 caninos, 8 premolares y 12 molares (incluyendo las 4 muelas del juicio)."
  },
  { 
    id: 214, 
    question: "El músculo masetero está inervado por el nervio:", 
    options: ["Facial", "Trigémino", "Hipogloso", "Accesorio"], 
    correctAnswer: 1, 
    region: "cabeza",
    explanation: "El nervio trigémino (V par craneal), específicamente su rama mandibular, inerva todos los músculos de la masticación incluyendo el masetero."
  },
  { 
    id: 215, 
    question: "¿Qué estructura separa las fosas nasales?", 
    options: ["Cornete", "Tabique nasal", "Vómer solamente", "Etmoides"], 
    correctAnswer: 1, 
    region: "cabeza",
    explanation: "El tabique nasal divide la cavidad nasal en dos fosas nasales. Está formado por cartílago en la parte anterior y hueso (vómer y lámina perpendicular del etmoides) en la posterior."
  },
  { 
    id: 216, 
    question: "La arteria carótida externa irriga principalmente:", 
    options: ["Cerebro", "Cara y cuero cabelludo", "Oído interno", "Médula espinal"], 
    correctAnswer: 1, 
    region: "cabeza",
    explanation: "La arteria carótida externa irriga estructuras externas de la cabeza: cara, cuero cabelludo, lengua, faringe y glándulas salivales. La carótida interna irriga el cerebro."
  },
  { 
    id: 217, 
    question: "¿Qué nervio craneal controla el movimiento ocular lateral?", 
    options: ["III (Oculomotor)", "IV (Troclear)", "VI (Abducens)", "VII (Facial)"], 
    correctAnswer: 2, 
    region: "cabeza",
    explanation: "El nervio abducens (VI par craneal) inerva el músculo recto lateral del ojo, permitiendo el movimiento de abducción (mirar hacia fuera lateralmente)."
  },
  { 
    id: 218, 
    question: "El conducto auditivo externo está en el hueso:", 
    options: ["Temporal", "Parietal", "Esfenoides", "Occipital"], 
    correctAnswer: 0, 
    region: "cabeza",
    explanation: "El conducto auditivo externo es un canal que va desde el pabellón auricular hasta el tímpano, y está contenido en la porción timpánica del hueso temporal."
  },
  { 
    id: 219, 
    question: "¿Cuántos huesecillos hay en el oído medio?", 
    options: ["2", "3", "4", "5"], 
    correctAnswer: 1, 
    region: "cabeza",
    explanation: "El oído medio contiene 3 huesecillos: martillo, yunque y estribo. Son los huesos más pequeños del cuerpo y transmiten vibraciones del tímpano al oído interno."
  },
  { 
    id: 220, 
    question: "La fontanela anterior se cierra aproximadamente a los:", 
    options: ["6 meses", "12 meses", "18 meses", "24 meses"], 
    correctAnswer: 2, 
    region: "cabeza",
    explanation: "La fontanela anterior (bregmática) generalmente se cierra entre los 18 y 24 meses de edad. Permite el crecimiento cerebral y facilita el paso por el canal del parto."
  }
];
